'use strict';

/**
 * Updates the product attribute in the Product Detail Page
 *
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} attrValue - Attribute value for the passed attrbute id
 * @param {string} className - Attribute class name to be changed
 */
function updateAttribute($productContainer, attrValue, className) {
    var $container = $productContainer.find(className);
    if (attrValue && attrValue.length > 0) {
        $container.find(className + '-value').html(attrValue);
        $container.removeClass('d-none');
    } else {
        $container.find(className + '-value').empty();
        $container.addClass('d-none');
    }
}

/**
 * Updates the product attributes related to Serengeti in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttributes(response, $productContainer) {
    $productContainer.find('.lens-attributes').removeClass('d-none');
    $productContainer.find('.product-name').html(response.product.productName);
    updateAttribute($productContainer, response.product.frameColor, '.frame-color');
    updateAttribute($productContainer, response.product.lensName, '.lens-name');
    updateAttribute($productContainer, response.product.baseCurve, '.base-curve');
    updateAttribute($productContainer, response.product.lensCategory, '.lens-category');
    updateAttribute($productContainer, response.product.boxingSize, '.boxing-size');
    updateAttribute($productContainer, response.product.lensSize, '.size');
    updateAttribute($productContainer, response.product.rx, '.details-rx');
    updateAttribute($productContainer, response.product.countryOrigin, '.country-origin');
    updateAttribute($productContainer, response.product.manufacturerSKU, '.manufacturer-skus');
    updateAttribute($productContainer, response.product.productMaterial, '.product-material');
    updateAttribute($productContainer, response.product.frameColor, '.product-frame-color');

    if (response.product.lensMaterial && response.product.lensMaterial.length > 0) {
        $productContainer.find('.lens-material-value').html(response.product.lensMaterial);
        $productContainer.find('.lens-material-value').removeClass('d-none');
    } else {
        $productContainer.find('.lens-material-value').empty();
        $productContainer.find('.lens-material-value').addClass('d-none');
    }

    if (response.product.specificTechnology && response.product.specificTechnology.length > 0) {
        $productContainer.find('.specific-technology-value').empty();
        var specificTechnologyHtml = '';
        response.product.specificTechnology.forEach(function (value) {
            specificTechnologyHtml += '<li>' + value + '</li>';
        });
        $productContainer.find('.specific-technology-value').html(specificTechnologyHtml);
    }
}

module.exports = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        updateAttributes(response.data, response.container);
    });
};